/**
 * Application Configuration structure
 *
 * @export
 * @interface IApplicationConfiguration
 */
 export interface IApplicationConfiguration {
  serviceEndpoint: string;
  baseUrl: string;
  ssoUrl: string;
}

/**
* ApplicationConfigProvider
*
* @export
* @class ApplicationConfigProvider
*/
export class ApplicationConfigProvider {
  private static _instance: ApplicationConfigProvider;
  private static _env: string;

  /**
   * Application configurations for local development
   *
   * @private
   * @static
   * @type {IApplicationConfiguration}
   * @memberof ApplicationConfigProvider
   */
  private static appConfigDev: IApplicationConfiguration = {
      serviceEndpoint: '//localhost:40876/',
      baseUrl: 'http://localhost:4088',
      // 'https://sso.didaadmin.com'
      ssoUrl: 'https://sso-v2.didaadmin.com'
  };

  /**
   * Application configurations for production environment
   *
   * @private
   * @static
   * @type {IApplicationConfiguration}
   * @memberof ApplicationConfigProvider
   */
  private static appConfigProd: IApplicationConfiguration = {
      serviceEndpoint: '//a-webapi.didaadmin.com/',
      baseUrl: 'https://a.didaadmin.com',
      ssoUrl: 'https://sso-v2.didaadmin.com'
  };

  private config: IApplicationConfiguration;

  constructor () {
      let config: IApplicationConfiguration = ApplicationConfigProvider.appConfigProd
      // tslint:disable-next-line
      if (typeof location !== 'undefined') {
        
        const hostName = location.hostname
        switch (hostName) {
        case 'a.didaadmin.com':
            ApplicationConfigProvider._env = 'prod'
            config = ApplicationConfigProvider.appConfigProd
            break
        case 'localhost':
            ApplicationConfigProvider._env = 'dev'
            config = ApplicationConfigProvider.appConfigDev
            break
        default:
            // when no host name is match:
            // * use prod config if node environment was set to `production`
            // * use dev config if node environment was not set to `production`
            if (process.env.NODE_ENV === 'production') {
                ApplicationConfigProvider._env = 'prod'
                config = ApplicationConfigProvider.appConfigProd
            } else {
                ApplicationConfigProvider._env = 'dev'
                config = ApplicationConfigProvider.appConfigDev
            }
            break
        }
      }
        
      this.config = Object.assign({}, config)
  }

  static get current (): IApplicationConfiguration {
      if (!ApplicationConfigProvider._instance) {
          ApplicationConfigProvider._instance = new ApplicationConfigProvider()
      }
      return ApplicationConfigProvider._instance.config
  }

  static reload (): void {
      ApplicationConfigProvider._instance = new ApplicationConfigProvider()
  }

  static get env (): string {
      return ApplicationConfigProvider._env
  }
}